import { render } from "./routeraccount.vue?vue&type=template&id=f0796708"
import script from "./routeraccount.vue?vue&type=script&lang=js"
export * from "./routeraccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__